import "./Article.scss";
import Comments from "../Comments/Comments";
import { MdFavorite } from "react-icons/md";
import { MdVisibility } from "react-icons/md";

function Article({ video, comments }) {
  const videoDate = new Date(video.timestamp).toLocaleDateString();

  return (
    <section className="article">
      <h1 className="article__heading">{video.title}</h1>
      <div className="article__info">
        <div className="article__info--left">
          <p className="article__author">By {video.channel}</p>
          <p className="article__date">{videoDate}</p>
        </div>
        <div className="article__info--right">
          <p className="article__views">
            <MdVisibility className="article__views--icon" />
            {video.views}
          </p>
          <p className="article__likes">
            <MdFavorite className="article__likes--icon" />
            {video.likes}
          </p>
        </div>
      </div>
      <p className="article__text">{video.description}</p>
      {/* comments section */}
      <Comments video={video} comments={comments} />
    </section>
  );
}

export default Article;
